var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWithText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.87 74.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.57,4.01c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.4,4.01c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.98,4.01c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.57,
    cy: 2.47,
    r: 1.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 47.4,
    cy: 2.47,
    r: 1.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.57,12.85c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.15,12.85c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.57,8.43c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.15,8.43c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.36,10.64c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.36,6.22c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.57,4.01c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.4,12.85c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.4,8.43c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.98,8.43c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.78,10.64c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.19,10.64c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.78,6.22c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.19,6.22c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.57,
    cy: 11.3,
    r: 1.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.57,8.43c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.4,4.01c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.98,4.01c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.57,4.01c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.82,12.85c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.82,8.43c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.61,10.64c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.61,6.22c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 47.4,
    cy: 11.3,
    r: 1.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.4,8.43c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.4,4.01c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.57,17.27c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.15,17.27c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.36,15.06c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.57,12.85c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.15,12.85c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.4,17.27c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.57,17.27c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.4,12.85c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.57,12.85c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.82,17.27c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.61,15.06c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.4,17.27c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.82,12.85c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.4,12.85c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55-1.55.69-1.55,1.55.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.22,14.88c.22.11.46.18.72.18.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55c-.26,0-.51.07-.72.18v2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.94,10.64c.85,0,1.55-.69,1.55-1.55s-.67-1.52-1.5-1.54c-.36.93-.6,1.92-.71,2.94.2.09.42.15.66.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.7,6.02c.43-.25.73-.69.77-1.21-.28.39-.54.79-.77,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.12,4.01s.02,0,.03,0c.84,0,1.52-.67,1.54-1.5-.57.45-1.1.95-1.57,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.78,1.8c.85,0,1.55-.69,1.55-1.55,0-.09,0-.17-.02-.26-1.06.06-2.07.26-3.04.58.15.7.77,1.22,1.51,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.19,1.8c.74,0,1.36-.52,1.51-1.22-.96-.32-1.98-.52-3.04-.58-.01.08-.02.17-.02.26,0,.85.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.28,2.51c.02.83.71,1.5,1.54,1.5.01,0,.02,0,.03,0-.48-.55-1.01-1.05-1.58-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.27,6.02c-.23-.42-.49-.82-.78-1.21.04.52.35.96.78,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.98,7.55c-.83.03-1.5.71-1.5,1.54s.69,1.55,1.55,1.55c.24,0,.46-.05.66-.15-.11-1.03-.35-2.01-.71-2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.76,12.15c-.22-.11-.46-.18-.72-.18-.85,0-1.55.69-1.55,1.55s.69,1.55,1.55,1.55c.26,0,.51-.07.72-.18v-2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.99,11.11c.61,0,1.14.36,1.38.88.1-.21.16-.44.16-.69,0-.85-.69-1.55-1.55-1.55s-1.55.69-1.55,1.55c0,.25.06.48.16.69.24-.52.77-.88,1.38-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.51,19.18h1.59c.39-.28.64-.74.64-1.25,0-.85-.69-1.55-1.55-1.55-.24,0-.48.06-.68.16v2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.87,19.18h1.59v-2.64c-.21-.1-.44-.16-.68-.16-.85,0-1.55.69-1.55,1.55,0,.51.25.97.64,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.51,12.64v2.26c.21.1.44.16.68.16.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55c-.28,0-.53.07-.76.2.05.15.08.31.08.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.78,15.06c.24,0,.48-.06.68-.16v-2.26c0-.17.03-.33.08-.48-.22-.13-.48-.2-.76-.2-.85,0-1.55.69-1.55,1.55s.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.78,19.18c-.28-.36-.72-.59-1.21-.59s-.93.23-1.21.59h2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.36,19.18c-.28-.36-.72-.59-1.21-.59s-.93.23-1.21.59h2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.45,19.18h1.82c.39-.28.64-.74.64-1.25,0-.85-.69-1.55-1.55-1.55s-1.55.69-1.55,1.55c0,.51.25.97.64,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.85,19.18c.39-.28.64-.74.64-1.25,0-.85-.69-1.55-1.55-1.55-.26,0-.51.07-.72.18v2.62h1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.61,19.18c-.28-.36-.72-.59-1.21-.59s-.93.23-1.21.59h2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.03,19.18c-.28-.36-.72-.59-1.21-.59s-.93.23-1.21.59h2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.12,19.18h1.63v-2.62c-.22-.11-.46-.18-.72-.18-.85,0-1.55.69-1.55,1.55,0,.51.25.97.64,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.7,19.18h1.82c.39-.28.64-.74.64-1.25,0-.85-.69-1.55-1.55-1.55s-1.55.69-1.55,1.55c0,.51.25.97.64,1.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.99,47.46c-9.98,0-18.09-8.12-18.09-18.09,0-.86.7-1.56,1.56-1.56s1.56.7,1.56,1.56c0,8.25,6.71,14.96,14.96,14.96s14.96-6.71,14.96-14.96c0-.86.7-1.56,1.56-1.56s1.56.7,1.56,1.56c0,9.98-8.12,18.09-18.09,18.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.51,22.24v18.86c5.78-.75,10.24-5.68,10.24-11.66v-7.2h-10.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.46,22.24h-10.24v7.2c0,5.98,4.47,10.91,10.24,11.66v-18.86Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.39,74.32c-.31.37-.69.57-1.16.61-.58.03-1.28.06-2.07.06h-.02c-.5,0-1.04-.02-1.64-.06-.47-.03-.88-.25-1.21-.67-.21-.28-.34-.62-.37-1.03h.56c.04.63.57,1.12,1.2,1.14.34.01.83.01,1.46.01-.28,0,.03.01.93.03.43.01.78-.01,1.06-.06.36-.07.64-.19.81-.37.23-.24.34-.54.34-.89,0-.87-.44-1.3-1.31-1.3h-3.34c-.44-.06-.81-.21-1.1-.49-.32-.3-.47-.65-.47-1.08s.14-.79.44-1.09c.3-.31.66-.46,1.09-.47.74-.01,1.38-.02,1.92-.02h.02c.31,0,.84.01,1.58.02.43.01.79.17,1.09.47.3.3.45.66.45,1.09,0,.04,0,.09-.01.14h-.61c.01-.06.01-.1.01-.15,0-.57-.45-.98-1.03-.99-.32-.01-.88-.01-1.69-.01.21,0-.06-.01-.79-.02-.36-.01-.67.01-.92.04-.32.04-.55.13-.69.28-.2.19-.3.42-.3.69s.1.52.29.71c.39.36.97.3,1.63.3h.74c1.69,0,2.08-.01,1.19-.02,1.03.01,1.73.31,2.1.87.19.3.29.64.29,1.03,0,.47-.14.89-.44,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.63,74.94h-.57v-1.99h-5.79v1.99h-.56v-2.99s-.01-.1-.01-.1c0-.84,0-1.29.01-1.36.06-.46.21-.85.49-1.16.3-.34.66-.52,1.11-.55.65-.04,1.2-.07,1.64-.07.76,0,1.47.02,2.1.07.45.03.83.21,1.11.54.26.3.42.68.47,1.16.01.13.02.58.02,1.35v.02c0,1.73-.01,2.77-.02,3.09ZM24.06,70.57c0-.67-.53-1.24-1.2-1.25-.36-.01-1-.01-1.92-.01h-.09c-.54,0-1,0-1.38.01-.67.01-1.2.57-1.2,1.25v1.81h5.79v-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.09,68.73l-2.8,6.21h-.6s-2.15-5.47-2.15-5.47l-2.16,5.47h-.6l-2.8-6.21h.58l2.5,5.53,2.17-5.53h.58l2.17,5.53,2.5-5.53h.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.75,69.24h-3.09v5.7h-.53v-5.7h-3.16v-.53h6.78v.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.29,74.94h-.56c-.01-.3-.01-1.31-.01-3.05v-3.14h.57v6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.19,74.94h-.56c-.01-.3-.01-1.31-.01-3.05v-3.14h.57v6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.84,74.94c-.36.01-1.46.02-3.25.01h-3.28v-.04h-.01v-6.22h.53v5.65h6.01v.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.57,74.94h-.57v-1.99h-5.79v1.99h-.56v-2.99s-.01-.1-.01-.1c0-.84,0-1.29.01-1.36.06-.46.21-.85.49-1.16.3-.34.66-.52,1.11-.55.65-.04,1.2-.07,1.64-.07.76,0,1.47.02,2.1.07.45.03.83.21,1.11.54.26.3.42.68.47,1.16.01.13.02.58.02,1.35v.02c0,1.73-.01,2.77-.02,3.09ZM67,70.57c0-.67-.53-1.24-1.2-1.25-.36-.01-1-.01-1.92-.01h-.09c-.54,0-1,0-1.38.01-.67.01-1.2.57-1.2,1.25v1.81h5.79v-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.83,74.96h-.68l-2.86-3.55-2.4,1.94v1.61h-.53v-6.21h.53v3.93l4.87-3.93h.84l-2.9,2.33,3.13,3.88Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.81,60.11H4.03c-2.69,0-4.03-1.19-4.03-3.59v-2.17h1.41v2.17c0,.82.24,1.41.72,1.74.38.27.96.41,1.74.41h4.31c.42,0,.71-.14.85-.43.1-.19.15-.52.15-.96v-5.34h1.42v5.26c0,.75-.1,1.23-.32,1.47h2.52v1.45ZM6.94,55.18h-3.16v-.85h.68c-.09-.19-.14-.41-.14-.62,0-.8.57-1.43,1.37-1.43.56,0,.95.25,1.17.76l-.6.41c-.09-.27-.27-.41-.53-.41-.38,0-.57.24-.57.72,0,.24.06.43.18.57h1.6v.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.14,60.11h-2.8v-1.45h2.8v1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.65,60.11h-2.8v-1.45h2.8v1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.16,60.11h-2.8v-1.45h2.8v1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.67,60.11h-2.8v-1.45h2.8v1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.18,60.11h-2.8v-1.45h2.8v1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.69,60.11h-2.8v-1.45h2.8v1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.99,57.81c0,1.53-.71,2.29-2.13,2.29h-1.5v-1.45h1.2c.47,0,.76-.14.9-.42.06-.15.1-.46.1-.91v-5.4h1.42v5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.11,62.71h-2.19v-.58h.51c-.08-.24-.11-.39-.11-.44,0-.6.44-1.05.99-1.05.36,0,.62.19.8.58l-.46.22c-.04-.19-.16-.28-.36-.28-.25,0-.43.24-.43.49,0,.23.08.39.23.48h1.03v.58ZM33.7,60.11h-1.41v-8.19h1.41v8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.68,58.66v1.45c-1.56,0-2-.24-2.59-1.12-.41,1.98-2.1,3.22-4.17,3.22-2.43,0-4.36-1.9-4.36-4.4v-1.42h1.42v1.26c0,1.97,1.14,3.2,2.98,3.2,1.65,0,2.89-1.09,2.89-2.38,0-.79-.47-1.34-1.28-1.34-.08,0-.15,0-.23.01v-1.29h.56c1.12,0,1.95.51,2.51,1.51.52.95,1.01,1.32,1.74,1.32h.53ZM41.43,65.02h-1.39v-1.41h1.39v1.41ZM43.82,65.02h-1.39v-1.41h1.39v1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.13,60.11h-2.8v-1.45h2.8v1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.64,60.11h-2.8v-1.45h2.8v1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.15,60.11h-2.8v-1.45h2.8v1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.66,60.11h-2.8v-1.45h2.8v1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.17,60.11h-2.8v-1.45h2.8v1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.68,60.11h-2.8v-1.45h2.8v1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.65,53.19h-1.39v-1.41h1.39v1.41ZM67.08,57.81c0,1.53-.71,2.29-2.12,2.29h-1.5v-1.45h1.19c.47,0,.76-.14.9-.42.06-.15.1-.46.1-.91v-2.98h1.42v3.46ZM67.04,53.19h-1.39v-1.41h1.39v1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.49,60.11h-1.72c-.19,1.39-1.12,2.09-2.76,2.09v-1.12c.74,0,1.2-.3,1.41-.98h-1.36c-1.53,0-2.78-1.28-2.78-2.95s1.23-2.81,2.84-2.81,2.64,1.19,2.64,2.85v1.47h1.74v1.45ZM72.33,58.66v-1.74c-.08-.75-.51-1.28-1.24-1.28-.84,0-1.37.58-1.37,1.43s.6,1.58,1.36,1.58h1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.81,60.11h-10.61v-1.45h1.04c.72,0,1.08-.49,1.08-1.5v-2.21h1.42v1.74c1.1-1.52,2.51-2.37,3.87-2.37,2.18,0,3.27,1.5,3.27,4.46,0,.42-.03.85-.06,1.32ZM84.4,58.66l.03-.41c0-1.64-.76-2.66-1.97-2.66-1.42,0-2.93,1.32-3.71,3.07h5.65Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 69.25,
    y: 61.08,
    width: 1.77,
    height: 1.11
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithText);
export default __webpack_public_path__ + "static/media/logoWithText.2aa879c6c7ffddab78622d95ef7841cf.svg";
export { ForwardRef as ReactComponent };